import React from "react";

import performance from "../../../assets/img/portfolio/performance.svg";
import development from "../../../assets/img/portfolio/development.svg";
import design from "../../../assets/img/portfolio/design.svg";
import web_responsive from "../../../assets/img/portfolio/web_responsive.svg";

const ServicesPortfolio = () => {
	const arrservices = [
		{
			id: 1,
			title: "performance",
			description: "Retaining users is crucial to improving conversion. High-performing sites engage and retain users.",
			img: performance,
		},
		{
			id: 2,
			title: "development",
			description: "I konw the importance of web develop and i can help you to create a website, you'll love.",
			img: development,
		},
		{
			id: 3,
			title: "Design",
			description:
				"A good and attractive website helps you keep your leads on your site, which is the digital face your business.",
			img: design,
		},
		{
			id: 4,
			title: "Web responsive",
			description:
				"Your site will display property on any device, including desktop computers, tablets and mobile phones.",
			img: web_responsive,
		},
	];

	return (
		<main className="services-portfolio  main__container" id="services">
			<div className="services-portfolio__content">
				<h2>Services</h2>
				<div className="services-portfolio__grid">
					{arrservices.map((service) => (
						<article key={service.id} className=" service-portfolio__service">
							<img src={service.img} alt={service.title} />
							<h3>{service.title}</h3>
							<p>{service.description}</p>
						</article>
					))}
				</div>
			</div>
		</main>
	);
};

export default ServicesPortfolio;
